import { render, staticRenderFns } from "./skeleton02.vue?vue&type=template&id=14210394&scoped=true"
import script from "./skeleton02.vue?vue&type=script&lang=js"
export * from "./skeleton02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14210394",
  null
  
)

export default component.exports